// src/components/VilkarKort.jsx
// Kort øverst i booking- og serviceportalen med lenke til servicebetingelsene.
// Kunden godtar ikke noe her (eier 12.10.2026): online-bookinger godtar med
// avkrysning før «Bekreft booking», og ved bookinger i butikk, fra chat eller
// akutt informerer den ansatte kunden om betingelsene. Se samtykke-plan.md § 2.
import React from "react";

export default function VilkarKort({ vilkar }) {
  if (!vilkar) return null;

  const url = vilkar.url || "https://roykensykkelservice.no/salgsbetingelser";

  return (
    <section className="border border-gray-300 rounded-lg p-4 mb-4 bg-gray-50" aria-labelledby="vilkar-kort-tittel">
      <h2 id="vilkar-kort-tittel" className="font-semibold text-lg text-gray-900">Servicebetingelser</h2>
      <p className="text-sm text-gray-800 mt-1">
        Vi utfører servicen etter servicebetingelsene våre.
        {vilkar.godtatt ? " Du godtok dem da du bestilte." : ""}{" "}
        <a href={`${url}#verksted`} target="_blank" rel="noopener noreferrer" className="underline text-blue-700">
          Les servicebetingelsene
        </a>
      </p>
      {vilkar.elsykkel && (
        <p className="text-sm text-gray-700 mt-2">
          Elsykkel: ved førstegangsservice, motorservice, programvareoppdatering og reklamasjonsvurdering
          henter produsenten data fra motorsystemet (ikke navn eller kontaktopplysninger), se{" "}
          <a href={`${url}#elsykkel`} target="_blank" rel="noopener noreferrer" className="underline text-blue-700">
            punkt A.8
          </a>
          .
        </p>
      )}
    </section>
  );
}
